import { createAction, handleActions } from "redux-actions";
import update from "immutability-helper";
import Axios from "../../utils/request";

const STUDENT_LIST = "auth/STUDENT_LIST";
const STUDENT_LIST_LOADING = "auth/STUDENT_LIST_LOADING";
const STUDENT_LIST_SUCCESS = "auth/STUDENT_LIST_SUCCESS";
const STUDENT_LIST_ERROR = "auth/STUDENT_LIST_ERROR";

function _getStudentList(orgId,data) {
  return Axios.get(`/academy/v2/accounts/${orgId}/students`,data);
}

export const getStudentList = orgId => (dispatch, getState,data) => {
  console.log("get STUDENT list: ", orgId);
  dispatch({
    type: STUDENT_LIST_LOADING
  });
  return _getStudentList(orgId, data)
    .then(res => {
      dispatch({
        type: STUDENT_LIST_SUCCESS,
        payload: res
      });
      return res;
    })
    .catch(e => {
      dispatch({
        type: STUDENT_LIST_ERROR,
        payload: e
      });
      return e;
    });
};

const initialState = {
  pending: false,
  studentList: [],
  error: {
    triggered: false,
    code: null,
    message: null
  }
};

export default handleActions(
  {
    [STUDENT_LIST_LOADING]: (state, { payload }) => {
      return {
        ...state,
        pending: true
      };
    },
    [STUDENT_LIST_SUCCESS]: (state, { payload }) => {
      console.log("get STUDENT list success: ", payload);
      return {
        ...state,
        pending: false,
        studentList: payload
      };
    },
    [STUDENT_LIST_ERROR]: (state, { payload }) => {
      return {
        ...state,
        pending: false,
        studentList: []
      };
    }
  },
  initialState
);
